import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LocalTable } from '../../table.class';
import { Tag, ColFilter } from '../../filter.class';
import { Fade } from '../../../../../../animations/animations';
import { Col } from '../../../../cols/col.class';
import { Options } from '../../../../../../components/options/options.component';
import { FocusOut } from '../../../../../../utils/focusOut.class';

@Component({
   selector: 'app-global-filter',
   template: `
      <div class="filter">
         <input   class="globalFilter"  
                  [(ngModel)]="ctx.filter.global.searchable"  
                  placeholder="Type for global search"
                  (keyup)="globalSearch()"
                  (keyup.enter)="customSelect()"
                  (blur)="focusOut.handler($event)"
                  #Searcher>
         <div class="tags">
            <app-tag *ngFor="let tag of ctx.filter.global.tags" 
                     [tag]="tag"
                     (onDelete)="delete($event)"
                     (onModeChange)="modeChange()"></app-tag>
         </div>
      </div>
      <section #Suggestions>
         <div class="suggestionByCol" *ngIf="ctx.filter.global.searchable.length >= 2" @Fade>
            <ng-container *ngFor="let pair of pairs">
               <ng-container *ngIf="pair.col.isVisible && pair.filter.searcher.isSomeFindings">
                  <div class="title">{{ pair.col.title() }}</div>
                  <app-options [ctx]="pair.options"></app-options>
               </ng-container>
            </ng-container>
         </div>
      </section>
  `,
   styleUrls: ['./global-filter.component.scss'],
   animations: [ Fade ]
})
export class GlobalFilterComponent implements AfterViewInit {
   @Input() ctx: LocalTable<any>;
   @ViewChild('Searcher') searcher: ElementRef<HTMLInputElement>;
   @ViewChild('Suggestions') suggestions: ElementRef<HTMLInputElement>;
   public pairs: Pair[] = [];
   public focusOut: FocusOut;

   constructor() { }

   ngAfterViewInit() {
      this.searcher.nativeElement.focus();
      this.focusOut = new FocusOut({
         host: this.suggestions.nativeElement,
         callback: () => this.ctx.filter.global.searchable = ``,
      })
      this.ctx.filter.byCol.forEach((filter, col) => {
         this.pairs.push({
            col,
            filter,
            options: {
               stream: filter.searcher.suggested,
               select: filter.searcher.ctx.select,
               title: filter.searcher.ctx.title,
               onBlur: this.focusOut.handler,
               
               style: 'static',
            }
         });
      });
   }


   public globalSearch() {
      if (this.ctx.filter.global.searchable.length >= 2) {
        this.ctx.filter.searchInCols();
      }
   }

   public customSelect() {
      this.ctx.filter.addGlobalTag();
   }

   public delete(tag: Tag) {
      this.ctx.filter.removeGlobalTag(tag);
   }  

   public modeChange() {
      this.ctx.filter.filterAll();
   }

}

interface Pair {
   col: Col<object>;
   filter: ColFilter<object>;
   options: Options<object>;
}